import {
  Globe,
  Lock,
  SignalHigh,
  SignalLow,
  SignalMedium,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { Difficulty, ExerciseCard, SubmissionStatus, Visibility } from '@train2volley/shared';

export const DIFFICULTY: Record<Difficulty, { label: string; icon: LucideIcon }> = {
  BEGINNER: { label: 'Beginner', icon: SignalLow },
  INTERMEDIATE: { label: 'Gemiddeld', icon: SignalMedium },
  ADVANCED: { label: 'Gevorderd', icon: SignalHigh },
};

export const VISIBILITY: Record<Visibility, { label: string; icon: LucideIcon }> = {
  PRIVATE: { label: 'Privé', icon: Lock },
  ORGANIZATION: { label: 'Club', icon: Users },
  PUBLIC: { label: 'Openbaar', icon: Globe },
};

export const CARD_STATUS: Record<NonNullable<ExerciseCard['status']>, string> = {
  DRAFT: 'Concept',
  SUBMITTED: 'In beoordeling',
  PUBLISHED: 'Gepubliceerd',
  REJECTED: 'Afgekeurd',
};

export const SUBMISSION_STATUS: Record<SubmissionStatus, string> = {
  SUBMITTED: 'In beoordeling',
  APPROVED: 'Goedgekeurd',
  REJECTED: 'Afgekeurd',
  WITHDRAWN: 'Ingetrokken',
};

/** "6–12", "6", "t/m 12", "–" — onbekend is nooit 0 (docs/03). */
export function playersLabel(min: number | null, max: number | null): string {
  if (min == null && max == null) return '–';
  if (min != null && (max == null || min === max)) return max == null ? `${min}+` : String(min);
  if (min == null) return `t/m ${max}`;
  return `${min}–${max}`;
}

export const durationLabel = (minutes: number | null) => (minutes == null ? '–' : `${minutes} min`);
